/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Dashboard example components
import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import MDCard from "components/MDCard";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Functions from store
import {
  createDynamicColumn,
  getBomReports,
  getDynamicColumn,
  getFinishedGoods,
  getFinishedGoodsWithoutPagination,
  getSubModulesByRoleId,
} from "../../../store";

import { CSVLink } from "react-csv";

// Cookies
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import Cookies from "universal-cookie";

import Config from "../../../config/index";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const BomReport = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getBomReports,
  getBomReportsReducer,
  createDynamicColumn,
  getDynamicColumn,

  getDynamicColumnReducer,

  getFinishedGoodsWithoutPagination,
  getFinishedGoodsWithoutPaginationReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [selectedfgCode, setSelectedfgCode] = useState("");

  useEffect(() => {
    getBomReports(selectedfgCode ? selectedfgCode.value : "", jwtToken);
  }, [selectedfgCode]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let bomMismatchModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "717ab107-2162-424e-a5fb-005b9ee0708b",
  );

  let viewAccess = bomMismatchModule
    ? bomMismatchModule.actionId.includes(
        "87c9ed57-2005-44c4-8208-98851fdcf532",
      )
    : null;

  const navigate = useNavigate();

  const [state, setState] = useState({
    columns: [
      { Header: "FG Model Code", accessor: "FG_Model_Code" },
      // { Header: "Item Description", accessor: "itemDescription" },
      { Header: "WO No", accessor: "WONo" },
      { Header: "Serial Number", accessor: "SerialNumber" },
      { Header: "Part Id", accessor: "PartId" },
      { Header: "VIN No", accessor: "VINNo" },
      { Header: "Required Quantity", accessor: "RequiredQuantity" },
      {
        Header: "Item Description",
        accessor: "itemDescription",
        align: "left",
        width: 320,
      },
      { Header: "wmsQty", accessor: "wmsQty" },
      { Header: "status", accessor: "status" },
      { Header: "status Mes", accessor: "statusMes" },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getBomReportsReducer.bomReports.data
      ? getBomReportsReducer.bomReports.data
      : [];
    setLoading(getBomReportsReducer.loading);
    data?.map((finishedGoods) => {
      let len = desLength;
      const finishedGoodsObject = {
        FG_Model_Code: finishedGoods.FG_Model_Code,
        itemDescriptionDownload: finishedGoods.itemDescription,
        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {finishedGoods?.itemDescription?.length > 35 ? (
              <Tooltip
                title={finishedGoods.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {finishedGoods.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {finishedGoods.itemDescription}
              </MDTypography>
            )}
            {finishedGoods?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),
        WONo: finishedGoods.WONo,
        SerialNumber: finishedGoods.SerialNumber,

        PartId: finishedGoods.PartId,
        VINNo: finishedGoods.VINNo,
        RequiredQuantity: finishedGoods.RequiredQuantity,
        wmsQty: finishedGoods.wmsQty,
        status: finishedGoods.status,
        statusMes: finishedGoods.statusMes,
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    viewAccess && setState({ ...state, rows: tempFinishedGoods });
  }, [getBomReportsReducer]);

  useEffect(() => {
    getFinishedGoodsWithoutPagination(jwtToken);
  }, []);

  const handlefgCodeChange = (selectedfgCode) => {
    setSelectedfgCode(selectedfgCode);
  };
  const [fgCodeOptions, setfgCodeOptions] = useState([]);

  useEffect(() => {
    let tempfgCodeOptions = [];
    let data = getFinishedGoodsWithoutPaginationReducer.finishedGoods.data
      ? getFinishedGoodsWithoutPaginationReducer.finishedGoods.data
      : [];
    data.map((item) => {
      // let des = item?.itemDescription;
      // let len = desLength;
      tempfgCodeOptions.push({
        label: `${item.fgModelCode}`,
        value: item.fgModelCode,
      });
    });
    setfgCodeOptions(tempfgCodeOptions);
  }, [getFinishedGoodsWithoutPaginationReducer]);

  const headers = [
    { label: "FG Model Code", key: "FG_Model_Code" },
    // { label: "Item Description", key: "itemDescription" },
    { label: "WO No", key: "WONo" },
    { label: "Serial Number", key: "SerialNumber" },
    { label: "Part Id", key: "PartId" },
    { label: "VIN No", key: "VINNo" },
    { label: "Required Quantity", key: "RequiredQuantity" },
    { label: "item Description", key: "itemDescriptionDownload" },
    { label: "wmsQty", key: "wmsQty" },
    { label: "status", key: "status" },
    { label: "status Mes", key: "statusMes" },
  ];

  const csvLink = {
    filename: "BOM Mismatch Report.csv",
    headers: headers,
    data: rows,
  };

  const subModuleId = "95815117-55fd-40be-ab8f-a9407d9ae1df";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getBomReports(selectedfgCode ? selectedfgCode.value : "", jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                flexDirection={{ xs: "column", lg: "row" }}
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-3}
                mt={-2}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} lg={8}>
                    <MDBox
                      display="flex"
                      flexDirection={{ xs: "column", lg: "row" }}
                      alignItems="center"
                      width="100%"
                    >
                      <MDBox
                        width={{ xs: "100%", lg: "200px" }}
                        mb={{ xs: 2, lg: 0 }}
                        mr={{ lg: 2 }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          FG Model Code
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={380}
                          autoComplete="off"
                          value={selectedfgCode}
                          options={fgCodeOptions}
                          onChange={handlefgCodeChange}
                        />
                      </MDBox>

                      <MDBox
                        style={{
                          marginTop: "25px",
                          marginLeft: { xs: 0, lg: "8px" },
                        }}
                      >
                        <CSVLink {...csvLink}>
                          <DownloadDataButton
                            type="button"
                            variant="outlined"
                            color="success"
                            iconOnly
                            style={{ borderRadius: "5px" }}
                            size="small"
                            tooltip="Download All Data"
                          >
                            <Icon>download</Icon>
                          </DownloadDataButton>
                        </CSVLink>
                      </MDBox>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
              <MDBox pt={3}>
                {loadingForDynamicColumn && (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <ToastContainer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,

    getBomReportsReducer: state.getBomReportsReducer,

    getFinishedGoodsReducer: state.getFinishedGoodsReducer,

    getFinishedGoodsWithoutPaginationReducer:
      state.getFinishedGoodsWithoutPaginationReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),

    getBomReports: (fgCode, jwtToken) =>
      dispatch(getBomReports(fgCode, jwtToken)),

    getFinishedGoods: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(getFinishedGoods(pageNo, rowsPerPage, searchObject, jwtToken)),
    getFinishedGoodsWithoutPagination: (jwtToken) =>
      dispatch(getFinishedGoodsWithoutPagination(jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(BomReport);
